import React from 'react';
import { history } from 'umi';

import styles from '../styles.scss';

export default (props) => {
  const {title,onMore,noMore} = props;

  return(
    <div className={styles.category_title}>
      <label className={styles.title_text}>{title}</label>

      {!noMore &&
      <label className={styles.more_text} onClick={()=>{
        onMore && onMore();
      }}>更多></label>}


    </div>
  )

}
